import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { deepExtract } from 'helpers/deep';
import { transformKeys, transformValues } from 'helpers/object';
import { isObject } from 'helpers/verify';
var CONTEXT_VARIABLE_REGEX = /\{([^{}]*)\}/g;

var normalizeVariable = function normalizeVariable(variable) {
  return (variable || '').toUpperCase();
};

var normalizeKeys = function normalizeKeys(object) {
  return transformKeys(normalizeVariable, transformValues(function (val) {
    return isObject(val) ? normalizeKeys(val) : val;
  }, object));
};

var determineValue = function determineValue(valueByVariable, match, variable) {
  return deepExtract(normalizeVariable(variable), valueByVariable, match);
};

var interpolateVariables = function interpolateVariables(valueByVariable, text) {
  return (text || '').replace(CONTEXT_VARIABLE_REGEX, determineValue.bind(null, valueByVariable));
};

var ContextVariables = React.createContext({});
export var DefineVariables = function DefineVariables(_ref) {
  var children = _ref.children,
      variables = _ref.variables;
  return React.createElement(ContextVariables.Consumer, null, function (contextVariables) {
    return React.createElement(ContextVariables.Provider, {
      value: _objectSpread({}, contextVariables, normalizeKeys(variables || {}))
    }, children);
  });
};
export var InterpolateVariables = function InterpolateVariables(_ref2) {
  var children = _ref2.children;
  return React.createElement(ContextVariables.Consumer, null, function (contextVariables) {
    return children(interpolateVariables.bind(null, contextVariables));
  });
};
DefineVariables.propTypes = {
  children: PropTypes.node.isRequired,
  variables: PropTypes.object
};
InterpolateVariables.propTypes = {
  children: PropTypes.func.isRequired
};